export const environment = {
    production: true,
    config:
    {
    baseUrl:
     {
        _common:'https://redtapeerp.com',
        _user:'https://redtapeerp.com/',
        _leads:'https://redtapeerp.com/',
        _booking:"https://redtapeerp.com/",
        _payment:"https://redtapeerp.com/",
        _inbound:'https://redtapeerp.com/',
        _leadHistory:'https://redtapeerp.com/',
        _patientInfo:'https://redtapeerp.com/',
        _ameyo: 'https://redtapeerp.com/',
        _lims_utility: 'https://redtapeerp.com/'
     },
    apiVer:'/api/v1',
    localJson:'assets/localJson.json',
    webSocket:"",
    baseFolder:"",
    utilityAppUrl:{lims_utility:''}
    }
};
